/*jslint browser */
/*global process */

import Dump from "../model/dump.model";

var $ = jQuery;

/**
 *
 */
export default class DumpService
{
    /**
     *
     * @private
     */
    private _dumps: Dump[];

    /**
     *
     */
    constructor() {
        this._dumps = [];
    }

    /**
     *
     * @param dump
     */
    public add(dump: Dump) {
        this._dumps.push(dump);
    }

    /**
     *
     */
    get dumps(): Dump[] {
        return this._dumps;
    }
}